(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-banner"] && !Shopify.designMode) return;
  try {
    
  // Desktop ≥990px scrolls .page-wrapper, not window. An IntersectionObserver
  // with root:null never sees that movement, which is why the card stayed at
  // opacity 0. Listen to the same target Horizon uses, and show the card as
  // soon as the pinned still covers the middle of the screen.
  class TbBannerReveal extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-bound')) return;
      this.setAttribute('data-bound', '');

      this.card = this.querySelector('[data-tb-banner-card]');
      this.pin = this.querySelector('.tb-banner__pin');
      if (!this.card || !this.pin) return;

      this.raf = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.squeeze = window.matchMedia('(min-width: 990px)');
      this.onScroll = this.onScroll.bind(this);
      this.onFrame = this.onFrame.bind(this);
      this.onMq = this.onMq.bind(this);

      this.reduce.addEventListener('change', this.onScroll);
      this.squeeze.addEventListener('change', this.onMq);
      this.bind();
      this.sync();
    }

    disconnectedCallback() {
      this.unbind();
      this.reduce?.removeEventListener('change', this.onScroll);
      this.squeeze?.removeEventListener('change', this.onMq);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    bind() {
      this.unbind();
      this.scrollTarget = this.squeeze.matches
        ? document.querySelector('.page-wrapper') ?? document
        : document;
      this.scrollTarget.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
    }

    unbind() {
      this.scrollTarget?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onMq() {
      this.bind();
      this.sync();
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(this.onFrame);
    }

    onFrame() {
      this.raf = 0;
      this.sync();
    }

    sync() {
      if (!this.card || !this.pin) return;

      if (this.reduce.matches) {
        this.card.classList.add('is-on');
        this.card.removeAttribute('inert');
        return;
      }

      const rect = this.pin.getBoundingClientRect();
      const vh = window.innerHeight;
      const shown = rect.top < vh * 0.72 && rect.bottom > vh * 0.28;
      this.card.classList.toggle('is-on', shown);
      this.card.toggleAttribute('inert', !shown);
    }
  }

  if (!customElements.get('tb-banner-reveal')) {
    customElements.define('tb-banner-reveal', TbBannerReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-before-after"] && !Shopify.designMode) return;
  try {
    
  // Range input writes --compare onto the track. No Horizon custom element:
  // that module only binds when comparison-slider-component upgrades, which
  // left this section as a frozen 50/50 split.
  function tbBaBind(root) {
    const track = root.querySelector('[data-tb-ba-track]');
    const input = root.querySelector('[data-tb-ba-input]');
    if (!track || !input || input.dataset.tbBound) return;
    input.dataset.tbBound = '1';

    const sync = () => {
      track.style.setProperty('--compare', input.value);
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  }

  function tbBaInit() {
    document.querySelectorAll('[data-tb-ba]').forEach(tbBaBind);
  }

  tbBaInit();
  document.addEventListener('shopify:section:load', tbBaInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-buy-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init() {
      const root = document.querySelector('[data-tb-buy-popup]');
      if (!(root instanceof HTMLElement)) return;
      if (root.hasAttribute('data-design-mode')) return;

      const STORAGE_KEY = 'tb-buy-popup-dismissed';
      const bar = root.querySelector('.tb-buy-popup__bar');
      const closeBtn = root.querySelector('[data-tb-buy-popup-close]');
      let dismissed = false;

      try {
        dismissed = sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        dismissed = false;
      }

      function setOpen(open) {
        const next = open && !dismissed;
        root.setAttribute('data-open', next ? 'true' : 'false');
        if (bar instanceof HTMLElement) {
          bar.setAttribute('aria-hidden', next ? 'false' : 'true');
        }
      }

      function sync() {
        if (dismissed) {
          setOpen(false);
          return;
        }

        const hero = document.querySelector('.tb-hero');
        const cta = document.querySelector('.tb-cta');
        const header = document.getElementById('header-group');
        const headerBottom = header instanceof HTMLElement ? header.getBoundingClientRect().bottom : 0;

        let pastHero = true;
        if (hero instanceof HTMLElement) {
          pastHero = hero.getBoundingClientRect().bottom <= headerBottom + 8;
        } else {
          pastHero = window.scrollY > 120;
        }

        let ctaInView = false;
        if (cta instanceof HTMLElement) {
          const rect = cta.getBoundingClientRect();
          const vh = window.innerHeight || 0;
          ctaInView = rect.top < vh - 40 && rect.bottom > 0;
        }

        setOpen(pastHero && !ctaInView);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          dismissed = true;
          try {
            sessionStorage.setItem(STORAGE_KEY, '1');
          } catch (error) {
            /* private mode */
          }
          setOpen(false);
        });
      }

      sync();
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      const hero = document.querySelector('.tb-hero');
      const cta = document.querySelector('.tb-cta');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(() => sync(), {
          root: null,
          threshold: [0, 0.15, 0.4, 0.7, 1],
        });
        if (hero) observer.observe(hero);
        if (cta) observer.observe(cta);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-consent"] && !Shopify.designMode) return;
  try {
    
  // Open only when Shopify.customerPrivacy.shouldShowBanner() is true and
  // the visitor has not chosen yet. That method is the admin region list.
  // Hosted #shopify-pc__banner is hidden from this section's CSS; do not
  // wait for this class. Portal onto body so position:fixed is the viewport.
  class TbConsent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tbBound) return;
      this.dataset.tbBound = '1';

      this.panel = this.querySelector('[data-tb-consent-panel]');
      this.saleRow = this.querySelector('[data-tb-consent-sale]');
      this.resize = new ResizeObserver(() => this.syncOffset());

      this.querySelector('[data-tb-consent-accept]')?.addEventListener('click', () => {
        this.submit({ analytics: true, marketing: true, preferences: true });
      });
      this.querySelector('[data-tb-consent-decline]')?.addEventListener('click', () => {
        this.submit({ analytics: false, marketing: false, preferences: false });
      });
      this.querySelector('[data-tb-consent-save]')?.addEventListener('click', () => {
        this.submit(this.readToggles());
      });
      this.querySelector('[data-tb-consent-manage]')?.addEventListener('click', () => this.openPanel());
      this.querySelector('[data-tb-consent-close-panel]')?.addEventListener('click', () => this.closePanel());

      document.addEventListener('tb:consent-open', () => this.reopen());
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-tb-consent-open]');
        if (!trigger) return;
        event.preventDefault();
        this.reopen();
      });

      this.loadApi();
    }

    loadApi() {
      const boot = () => {
        const shopify = window.Shopify;
        if (!shopify || typeof shopify.loadFeatures !== 'function') {
          window.setTimeout(boot, 50);
          return;
        }

        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) return;
          this.privacy = shopify.customerPrivacy;
          if (!this.privacy) return;
          if (this.privacy.saleOfDataRegion && this.privacy.saleOfDataRegion() && this.saleRow) {
            this.saleRow.hidden = false;
          }
          if (this.shouldOpen()) this.show();
        });
      };

      boot();
    }

    shouldOpen() {
      if (!this.privacy.shouldShowBanner || !this.privacy.shouldShowBanner()) return false;
      const current = this.privacy.currentVisitorConsent ? this.privacy.currentVisitorConsent() : {};
      return !current.analytics && !current.marketing && !current.preferences && !current.sale_of_data;
    }

    show() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
      this.hidden = false;
      this.resize.observe(this);
      this.syncOffset();
    }

    hide() {
      this.closePanel();
      this.hidden = true;
      this.resize.disconnect();
      this.syncOffset();
    }

    reopen() {
      if (!this.privacy) return;
      this.hydrateToggles();
      this.show();
      this.openPanel();
    }

    openPanel() {
      if (!this.panel) return;
      this.hydrateToggles();
      this.panel.hidden = false;
      this.syncOffset();
      this.panel.querySelector('input')?.focus();
    }

    closePanel() {
      if (!this.panel) return;
      this.panel.hidden = true;
      this.syncOffset();
    }

    hydrateToggles() {
      const current = this.privacy.currentVisitorConsent ? this.privacy.currentVisitorConsent() : {};
      this.querySelectorAll('[data-tb-consent-key]').forEach((input) => {
        const value = current[input.dataset.tbConsentKey];
        input.checked = input.hasAttribute('data-tb-consent-inverted')
          ? value === 'no'
          : value === 'yes';
      });
    }

    readToggles() {
      const next = {};
      this.querySelectorAll('[data-tb-consent-key]').forEach((input) => {
        if (input.closest('[hidden]')) return;
        const inverted = input.hasAttribute('data-tb-consent-inverted');
        next[input.dataset.tbConsentKey] = inverted ? !input.checked : input.checked;
      });
      return next;
    }

    submit(consent) {
      if (!this.privacy || typeof this.privacy.setTrackingConsent !== 'function') return;
      this.privacy.setTrackingConsent(consent, () => this.hide());
    }

    syncOffset() {
      const height = this.hidden ? 0 : this.offsetHeight;
      document.documentElement.style.setProperty('--tb-consent-offset', `${height}px`);
    }
  }

  if (!customElements.get('tb-consent')) {
    customElements.define('tb-consent', TbConsent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-email-gate"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-tb-gate]');
    if (!dialog) return;

    const STORAGE_KEY = 'tb-email-gate';
    const formWrap = dialog.querySelector('[data-tb-gate-form-wrap]');
    const done = dialog.querySelector('[data-tb-gate-done]');
    const form = dialog.querySelector('.tb-gate__form');
    const errorEl = dialog.querySelector('[data-tb-gate-error]');
    const submitBtn = dialog.querySelector('[data-tb-gate-submit]');
    const delayMs = 1800;

    const stored = () => {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (err) {
        return null;
      }
    };

    const persist = (value) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (err) {
        /* private mode: still close for this page view */
      }
    };

    const showDone = () => {
      if (formWrap) formWrap.hidden = true;
      if (done) done.hidden = false;
    };

    const open = () => {
      if (dialog.open) return;
      dialog.showModal();
    };

    const dismiss = (reason) => {
      persist(reason);
      if (dialog.open) dialog.close();
    };

    dialog.querySelectorAll('[data-tb-gate-dismiss]').forEach((btn) => {
      btn.addEventListener('click', () => dismiss(done && !done.hidden ? 'subscribed' : 'dismissed'));
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss(done && !done.hidden ? 'subscribed' : 'dismissed');
    });

    const consentBlocking = () => {
      const bar = document.querySelector('[data-tb-consent]');
      return Boolean(bar && !bar.hasAttribute('hidden'));
    };

    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const waitForConsent = async () => {
      const start = Date.now();
      while (consentBlocking() && Date.now() - start < 45000) {
        await wait(250);
      }
    };

    const submitToShopify = async (event) => {
      event.preventDefault();
      if (!form) return;

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (submitBtn) submitBtn.disabled = true;

      try {
        const body = new FormData(form);
        const response = await fetch(form.action || '/contact', {
          method: 'POST',
          body,
          headers: { Accept: 'application/javascript' },
        });

        if (!response.ok) throw new Error('subscribe-failed');

        persist('subscribed');
        showDone();
      } catch (err) {
        if (errorEl) {
          errorEl.textContent = dialog.getAttribute('data-tb-gate-error') || 'Could not subscribe. Try again.';
          errorEl.hidden = false;
        }
        form.submit();
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    };

    form?.addEventListener('submit', submitToShopify);

    if (dialog.hasAttribute('data-design-mode')) {
      open();
      return;
    }

    if (stored() === 'subscribed' || stored() === 'dismissed') return;

    (async () => {
      await wait(delayMs);
      await waitForConsent();
      if (stored() === 'subscribed' || stored() === 'dismissed') return;
      if (consentBlocking()) return;
      open();
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-featured-results"] && !Shopify.designMode) return;
  try {
    
  class TbStatsRings extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.rings = Array.from(this.querySelectorAll('[data-pct]'));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.squeeze = window.matchMedia('(min-width: 990px)');
      this.onMq = this.onMq.bind(this);
      this.squeeze.addEventListener('change', this.onMq);
      if (!this.rings.length || this.reduce.matches) return;
      this.reset();
      this.observe();
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.squeeze?.removeEventListener('change', this.onMq);
    }

    intersectionRoot() {
      if (this.squeeze.matches) return document.querySelector('.page-wrapper');
      return null;
    }

    reset() {
      this.rings.forEach((ring) => {
        const fill = ring.querySelector('.tb-stats__fill');
        const value = ring.querySelector('[data-tb-stats-value]');
        if (fill) fill.setAttribute('stroke-dashoffset', '100');
        if (value) value.textContent = '0%';
      });
    }

    observe() {
      this.io?.disconnect();
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.io.disconnect();
            this.play();
          });
        },
        { root: this.intersectionRoot(), threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
      );
      this.io.observe(this.querySelector('.tb-stats__panel') || this);
      window.setTimeout(() => {
        if (this.dataset.played === 'true') return;
        const root = this.intersectionRoot();
        const box = root ? root.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
        const panel = this.querySelector('.tb-stats__panel') || this;
        const r = panel.getBoundingClientRect();
        if (r.bottom > box.top + 8 && r.top < box.bottom - 8) this.play();
      }, 1400);
    }

    onMq() {
      if (this.dataset.played === 'true') return;
      this.observe();
    }

    play() {
      if (this.dataset.played === 'true') return;
      this.dataset.played = 'true';
      this.rings.forEach((ring, i) => {
        const target = Math.max(0, Math.min(100, Number(ring.getAttribute('data-pct')) || 0));
        window.setTimeout(() => this.animateRing(ring, target), i * 120);
      });
    }

    animateRing(ring, target) {
      const fill = ring.querySelector('.tb-stats__fill');
      const value = ring.querySelector('[data-tb-stats-value]');
      const duration = 1100;
      const start = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3);

      const frame = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = ease(t);
        const current = Math.round(target * eased);
        if (fill) fill.setAttribute('stroke-dashoffset', String(100 - current));
        if (value) value.textContent = current + '%';
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          if (fill) fill.setAttribute('stroke-dashoffset', String(100 - target));
          if (value) value.textContent = target + '%';
        }
      };
      requestAnimationFrame(frame);
    }
  }

  if (!customElements.get('tb-stats-rings')) {
    customElements.define('tb-stats-rings', TbStatsRings);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-footer"] && !Shopify.designMode) return;
  try {
    
  // Submit the localization form as soon as a country is picked, so the select
  // behaves like a menu. The noscript button covers the JS-off case.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-tb-locale-select]');
    if (!select) return;

    const form = select.closest('form');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  function tbJdgmWidget() {
    return document.getElementById('judgeme_product_reviews');
  }

  function tbJdgmThemeForm() {
    const s = window.jdgmSettings;
    if (!s) return;
    s.review_form_color_scheme = 'custom';
    s.review_form_corner_style = 'round';
    s.review_form_star_color = '#f5c518';
    s.review_form_text_color = '#1f1814';
    s.review_form_background_color = '#ffffff';
    s.review_form_field_background_color = '#ffffff';
    s.review_form_button_color = '#111111';
    s.review_form_button_text_color = '#ffffff';
    s.review_form_modal_overlay_color = '#111111';

    const widget = tbJdgmWidget();
    const terms = widget && widget.getAttribute('data-tb-terms-url');
    const privacy = widget && widget.getAttribute('data-tb-privacy-url');
    if (s.write_review_flow_gdpr_statement) {
      if (terms) {
        s.write_review_flow_gdpr_statement = s.write_review_flow_gdpr_statement.replace(
          /https:\/\/judge\.me\/terms[^'"]*/g,
          terms
        );
      }
      if (privacy) {
        s.write_review_flow_gdpr_statement = s.write_review_flow_gdpr_statement.replace(
          /https:\/\/judge\.me\/privacy[^'"]*/g,
          privacy
        );
      }
    }
  }

  function tbJdgmRetargetFormLinks(root) {
    const widget = tbJdgmWidget();
    const terms = widget && widget.getAttribute('data-tb-terms-url');
    const privacy = widget && widget.getAttribute('data-tb-privacy-url');
    if (!root) return;
    root.querySelectorAll('a[href]').forEach((anchor) => {
      const href = anchor.getAttribute('href') || '';
      if (terms && href.indexOf('judge.me/terms') !== -1) anchor.setAttribute('href', terms);
      if (privacy && href.indexOf('judge.me/privacy') !== -1) {
        anchor.setAttribute('href', privacy);
      }
    });
  }

  function tbJdgmWatchForm() {
    if (document.documentElement.dataset.tbJdgmFormWatch === 'true') return;
    document.documentElement.dataset.tbJdgmFormWatch = 'true';
    const attach = (node) => {
      if (!node || !node.querySelectorAll) return;
      const modal =
        node.matches && node.matches('.jdgm-write-review-modal')
          ? node
          : node.querySelector('.jdgm-write-review-modal');
      if (modal) tbJdgmRetargetFormLinks(modal);
    };
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) attach(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function tbJdgmWriteButton(root) {
    if (!root) return null;
    const selectors = [
      '[data-testid="write-review-button"]',
      'a.jdgm-write-rev-link',
      '.jdgm-write-rev-link',
    ];
    const search = (node) => {
      for (let i = 0; i < selectors.length; i++) {
        const el = node.querySelector(selectors[i]);
        if (el) return el;
      }
      return null;
    };
    const found = search(root);
    if (found) return found;
    if (root.shadowRoot) {
      const shadowed = search(root.shadowRoot);
      if (shadowed) return shadowed;
    }
    const nodes = root.querySelectorAll('*');
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        const shadowed = search(nodes[i].shadowRoot);
        if (shadowed) return shadowed;
      }
    }
    return null;
  }

  function tbJdgmClickWriteButton() {
    const btn = tbJdgmWriteButton(tbJdgmWidget());
    if (!btn) return false;
    btn.click();
    return true;
  }

  function tbJdgmHostedFormUrl(link) {
    const widget = tbJdgmWidget();
    const shop =
      (window.jdgm && jdgm.SHOP_DOMAIN) ||
      (widget && widget.getAttribute('data-tb-shop-domain')) ||
      '';
    const productId =
      (widget && (widget.getAttribute('data-product-id') || widget.getAttribute('data-id'))) ||
      (link && link.getAttribute('data-product-id')) ||
      '';
    if (!shop || !productId) return '';
    return (
      'https://api.judge.me/storefront_reviews/new?shop_domain=' +
      encodeURIComponent(shop) +
      '&platform=shopify&product_id=' +
      encodeURIComponent(productId)
    );
  }

  function tbJdgmOpenHostedForm(link) {
    const hosted = tbJdgmHostedFormUrl(link);
    if (!hosted) return;
    const popup = window.open(hosted, '_blank', 'noopener,noreferrer');
    if (!popup) window.location.assign(hosted);
  }

  function tbJdgmWaitForWriteButton(onReady, onTimeout) {
    const widget = tbJdgmWidget();
    if (!widget) {
      onTimeout();
      return function () {};
    }
    if (tbJdgmClickWriteButton()) {
      onReady();
      return function () {};
    }
    let done = false;
    const finish = (ok) => {
      if (done) return;
      done = true;
      observer.disconnect();
      window.clearTimeout(timer);
      if (ok) onReady();
      else onTimeout();
    };
    const observer = new MutationObserver(() => {
      if (tbJdgmClickWriteButton()) finish(true);
    });
    observer.observe(widget, { childList: true, subtree: true });
    const timer = window.setTimeout(() => finish(false), 12000);
    return function () {
      finish(true);
    };
  }

  function tbJdgmOpenWriteForm(link) {
    if (!tbJdgmWidget()) return;
    tbJdgmWaitForWriteButton(
      () => {},
      () => tbJdgmOpenHostedForm(link)
    );
  }

  function tbJdgmBindWriteLinks() {
    tbJdgmThemeForm();
    tbJdgmWatchForm();
    document.querySelectorAll('[data-tb-write-review]').forEach((link) => {
      if (link.dataset.tbWriteBound === 'true') return;
      link.dataset.tbWriteBound = 'true';
      link.addEventListener('click', (event) => {
        if (!tbJdgmWidget()) return;
        event.preventDefault();
        tbJdgmThemeForm();
        tbJdgmOpenWriteForm(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tbJdgmBindWriteLinks);
  } else {
    tbJdgmBindWriteLinks();
  }
  document.addEventListener('shopify:section:load', tbJdgmBindWriteLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-quote-slider"] && !Shopify.designMode) return;
  try {
    
  class TbQuoteSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i));
      });
      if (this.slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }
      if (typeof window.tbRevealCards === 'function') {
        window.tbRevealCards(this, '.tb-quotes__stage');
      }
    }

    go(nextIndex) {
      if (!this.slides.length) return;
      const n = this.slides.length;
      this.index = ((nextIndex % n) + n) % n;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('tb-quote-slider')) {
    customElements.define('tb-quote-slider', TbQuoteSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-review-wall"] && !Shopify.designMode) return;
  try {
    
  class TbReviewWall extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.dialog = this.querySelector('[data-dialog]');
      this.byId = new Map();
      const reviews = this.readReviews();
      this.indexReviews(reviews);
      this.renderCards(reviews);
      this.bindMore();
      this.bindCards();
      this.bindDialog();
      this.revealCards();
      window.addEventListener('resize', () => {
        window.clearTimeout(this._packTimer);
        this._packTimer = window.setTimeout(() => this.packColumns(), 120);
      });
    }

    parseJsonNode(selector) {
      const node = this.querySelector(selector);
      let data = {};
      try {
        data = JSON.parse(node ? node.textContent : '{}');
      } catch (e) {
        data = {};
      }
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {};
        }
      }
      return data || {};
    }

    readReviews() {
      const widget = this.parseJsonNode('[data-tb-jdgm]');
      const grid = this.parseJsonNode('[data-tb-jdgm-grid]');
      const pid = this.getAttribute('data-product-id');
      const live = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget
        ? window.jdgm.data.reviewWidget[pid]
        : null;
      const gallery = (live && live.photo_gallery) || widget.photo_gallery || [];
      const merged = this.mergeReviews(
        gallery,
        this.mergeReviews((live && live.reviews) || widget.reviews || [], grid.reviews || [])
      );
      return this.sortReviews(this.scopedReviews(merged));
    }

    sortReviews(list) {
      return (list || []).slice().sort((a, b) => {
        const aPic = this.hasPicture(a) ? 1 : 0;
        const bPic = this.hasPicture(b) ? 1 : 0;
        if (bPic !== aPic) return bPic - aPic;
        return Number(b.rating || b.score || 0) - Number(a.rating || a.score || 0);
      });
    }

    reviewId(raw) {
      return raw && (raw.uuid || raw.id) ? String(raw.uuid || raw.id) : '';
    }

    hasPicture(raw) {
      return Boolean(this.pictureUrl(this.mediaList(raw)));
    }

    mediaList(raw) {
      const lists = [
        raw && raw.pictures_urls,
        raw && raw.pictures,
        raw && raw.photos,
        raw && raw.videos_urls,
        raw && raw.videos
      ];
      for (let i = 0; i < lists.length; i += 1) {
        if (Array.isArray(lists[i]) && lists[i].length) return lists[i];
      }
      return [];
    }

    mergeReviews(primary, secondary) {
      const byId = new Map();
      const order = [];
      const add = (raw) => {
        const id = this.reviewId(raw);
        if (!id) return;
        const existing = byId.get(id);
        if (!existing) {
          byId.set(id, raw);
          order.push(id);
          return;
        }
        if (this.hasPicture(raw) && !this.hasPicture(existing)) {
          byId.set(id, Object.assign({}, existing, raw));
        }
      };
      (primary || []).forEach(add);
      (secondary || []).forEach(add);
      return order.map((id) => byId.get(id));
    }

    scopedReviews(list) {
      const handle = this.getAttribute('data-product-handle') || '';
      if (!handle) return list;
      const needle = '/products/' + handle;
      return list.filter((raw) => {
        const url = raw && raw.product_url;
        if (!url) return true;
        const path = String(url).split('?')[0];
        return path === needle || path.indexOf(needle + '/') === 0 || path.slice(-needle.length) === needle;
      });
    }

    indexReviews(list) {
      this.byId.clear();
      (list || []).forEach((raw) => {
        const review = this.normalize(raw);
        if (review.id) this.byId.set(String(review.id), review);
      });
    }

    normalize(raw) {
      const reviewer = raw.reviewer || raw.user || {};
      const pictures = this.mediaList(raw);
      const src = this.pictureUrl(pictures);
      return {
        id: raw.uuid || raw.id,
        name: raw.reviewer_name || raw.name || reviewer.name || '',
        rating: Number(raw.rating || raw.score || 0),
        body: raw.body || raw.content || this.stripHtml(raw.body_html || ''),
        title: raw.title || '',
        verified: this.isVerified(raw.verified_buyer || raw.verified || reviewer.verified_buyer),
        src: src,
        picCount: Array.isArray(pictures) ? pictures.length : 0,
        video: this.isVideo(src)
      };
    }

    stripHtml(value) {
      const node = document.createElement('div');
      node.innerHTML = value || '';
      return (node.textContent || '').trim();
    }

    isVerified(value) {
      if (value === true || value === 1) return true;
      if (typeof value !== 'string') return false;
      const key = value.toLowerCase();
      return key === 'buyer' || key === 'yes' || key === 'true' || key === 'verified-buyer' || key === 'verified';
    }

    isVideo(src) {
      if (!src) return false;
      const key = String(src).toLowerCase();
      return key.indexOf('.mp4') !== -1 || key.indexOf('.webm') !== -1;
    }

    pictureUrl(pictures) {
      if (!Array.isArray(pictures) || !pictures.length) return '';
      const first = pictures.find((item) => item && item.hidden !== true) || pictures[0];
      if (!first) return '';
      if (typeof first === 'string') {
        return first.indexOf('://') === -1 ? '' : first;
      }
      const urls = first.urls || first;
      const src = urls.huge || urls.compact || urls.original || urls.small || first.url || '';
      return typeof src === 'string' && src.indexOf('://') !== -1 ? src : '';
    }

    starSvg(on) {
      return (
        '<span class="tb-wall__star' +
        (on ? ' is-on' : '') +
        '" aria-hidden="true"><svg viewBox="0 0 20 20" width="15" height="15"><path d="M10 1.6l2.3 4.7 5.2.8-3.8 3.7.9 5.2L10 13.5 5.4 16l.9-5.2L2.5 7.1l5.2-.8L10 1.6z" fill="currentColor"/></svg></span>'
      );
    }

    starsHtml(rating) {
      let html = '';
      for (let i = 1; i <= 5; i += 1) html += this.starSvg(i <= rating);
      return html;
    }

    verifiedHtml(verified) {
      return (
        '<span class="tb-wall__verified"' +
        (verified ? ' title="Verified buyer"' : '') +
        '>' +
        '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.4 8.2l2.1 2.1 5.1-5.2" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        (verified ? '<span class="tb-wall__verified-label">Verified</span>' : '') +
        '</span>'
      );
    }

    initialCount() {
      const n = Number(this.getAttribute('data-initial'));
      return n > 0 ? n : 8;
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    escapeAttr(value) {
      return this.escapeHtml(value).replace(/'/g, '&#39;');
    }

    cardHtml(raw, hidden) {
      const review = this.normalize(raw);
      const src = review.src;
      const extraPics = review.picCount > 1 ? review.picCount - 1 : 0;
      return (
        '<article class="tb-wall__card' +
        (src ? '' : ' tb-wall__card--quote') +
        '" data-card data-review-id="' +
        this.escapeAttr(String(review.id || '')) +
        '" role="button" tabindex="0" aria-haspopup="dialog" aria-label="' +
        this.escapeAttr(review.name || 'Review') +
        '"' +
        (hidden ? ' hidden' : '') +
        '>' +
        (src
          ? '<div class="tb-wall__media">' +
            (review.video
              ? '<video src="' +
                this.escapeAttr(src) +
                '" muted playsinline preload="metadata" width="600" height="600"></video>' +
                '<span class="tb-wall__play" aria-hidden="true"><svg viewBox="0 0 48 48" width="48" height="48"><circle cx="24" cy="24" r="23" fill="#fff"/><path d="M20 16l14 8-14 8z" fill="#111"/></svg></span>'
              : '<img src="' +
                this.escapeAttr(src) +
                '" alt="" width="600" height="600" loading="lazy" decoding="async">') +
            (extraPics
              ? '<span class="tb-wall__more-pics" aria-hidden="true">+' + extraPics + '</span>'
              : '') +
            '</div>'
          : '') +
        '<div class="tb-wall__copy">' +
        (review.name
          ? '<p class="tb-wall__name">' +
            this.escapeHtml(review.name) +
            this.verifiedHtml(review.verified) +
            '</p>'
          : '') +
        (review.rating > 0
          ? '<p class="tb-wall__stars tb-wall__stars--card" aria-hidden="true">' +
            this.starsHtml(review.rating) +
            '</p>'
          : '') +
        (review.title ? '<p class="tb-wall__title">' + this.escapeHtml(review.title) + '</p>' : '') +
        (review.body ? '<p class="tb-wall__body">' + this.escapeHtml(review.body) + '</p>' : '') +
        '</div></article>'
      );
    }

    renderCards(list) {
      const grid = this.querySelector('.tb-wall__grid');
      if (!grid || !list || !list.length) return;
      const initial = this.initialCount();
      grid.innerHTML = list.map((raw, index) => this.cardHtml(raw, index >= initial)).join('');
      const moreWrap = this.querySelector('.tb-wall__more-wrap');
      const moreBtn = this.querySelector('[data-more]');
      if (moreWrap) moreWrap.hidden = list.length <= initial;
      if (moreBtn) moreBtn.hidden = list.length <= initial;
      this.packColumns();
      this.revealCards();
    }

    revealCards() {
      if (typeof window.tbRevealCards === 'function') {
        window.tbRevealCards(this, '.tb-wall__card');
      }
    }

    columnCount() {
      const grid = this.querySelector('.tb-wall__grid');
      if (!grid) return 1;
      const n = parseInt(getComputedStyle(grid).getPropertyValue('--tb-wall-cols'), 10);
      return n > 0 ? n : 1;
    }

    shortestColumn(cols) {
      let best = 0;
      for (let i = 1; i < cols.length; i += 1) {
        const shorter = cols[i].offsetHeight < cols[best].offsetHeight;
        const tiedFewer =
          cols[i].offsetHeight === cols[best].offsetHeight && cols[i].children.length < cols[best].children.length;
        if (shorter || tiedFewer) best = i;
      }
      return cols[best];
    }

    packColumns() {
      const grid = this.querySelector('.tb-wall__grid');
      if (!grid) return;
      const cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
      if (!cards.length) return;
      const n = this.columnCount();
      grid.querySelectorAll('.tb-wall__col').forEach((col) => col.remove());
      const cols = [];
      for (let i = 0; i < n; i += 1) {
        const col = document.createElement('div');
        col.className = 'tb-wall__col';
        grid.appendChild(col);
        cols.push(col);
      }
      let pool = grid.querySelector('.tb-wall__pool');
      if (!pool) {
        pool = document.createElement('div');
        pool.className = 'tb-wall__pool';
        pool.hidden = true;
        grid.appendChild(pool);
      }
      cards.forEach((card) => {
        if (card.hidden) pool.appendChild(card);
        else this.shortestColumn(cols).appendChild(card);
      });
      grid.classList.add('is-packed');
    }

    bindMore() {
      const btn = this.querySelector('[data-more]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        this.querySelectorAll('[data-card][hidden]').forEach((card) => {
          card.hidden = false;
        });
        btn.hidden = true;
        const wrap = this.querySelector('.tb-wall__more-wrap');
        if (wrap) wrap.hidden = true;
        this.packColumns();
        this.revealCards();
      });
    }

    bindCards() {
      const grid = this.querySelector('.tb-wall__grid');
      if (!grid) return;
      grid.addEventListener('click', (event) => {
        const card = event.target.closest('[data-review-id]');
        if (!card || !grid.contains(card) || card.hidden) return;
        this.openReview(card.getAttribute('data-review-id'));
      });
      grid.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-review-id]');
        if (!card || !grid.contains(card) || card.hidden) return;
        event.preventDefault();
        this.openReview(card.getAttribute('data-review-id'));
      });
    }

    bindDialog() {
      if (!this.dialog) return;
      const close = this.querySelector('[data-close]');
      if (close) close.addEventListener('click', () => this.closeReview());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeReview();
      });
      this.dialog.addEventListener('close', () => this.stopModalVideo());
    }

    stopModalVideo() {
      const video = this.dialog && this.dialog.querySelector('[data-modal-video]');
      if (!video) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
    }

    closeReview() {
      if (!this.dialog) return;
      this.stopModalVideo();
      if (typeof this.dialog.close === 'function') this.dialog.close();
    }

    openReview(id) {
      const review = this.byId.get(String(id));
      if (!review || !this.dialog) return;
      const img = this.dialog.querySelector('[data-modal-img]');
      const video = this.dialog.querySelector('[data-modal-video]');
      const name = this.dialog.querySelector('[data-modal-name]');
      const stars = this.dialog.querySelector('[data-modal-stars]');
      const body = this.dialog.querySelector('[data-modal-body]');
      const modal = this.dialog.querySelector('.tb-wall__modal');
      const hasMedia = Boolean(review.src);
      if (modal) modal.classList.toggle('tb-wall__modal--quote', !hasMedia);
      if (img) {
        img.hidden = !hasMedia || review.video;
        img.src = hasMedia && !review.video ? review.src : '';
      }
      if (video) {
        this.stopModalVideo();
        video.hidden = !hasMedia || !review.video;
        if (hasMedia && review.video) video.src = review.src;
      }
      if (name) {
        name.textContent = '';
        name.append(document.createTextNode(review.name || ''));
        if (review.verified) name.insertAdjacentHTML('beforeend', this.verifiedHtml(true));
      }
      if (stars) stars.innerHTML = this.starsHtml(review.rating);
      if (body) {
        const text = [review.title, review.body].filter(Boolean).join('\n\n');
        body.textContent = text;
      }
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      if (hasMedia && review.video && video) video.play().catch(() => {});
    }
  }

  if (!customElements.get('tb-review-wall')) {
    customElements.define('tb-review-wall', TbReviewWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-reviews"] && !Shopify.designMode) return;
  try {
    
  class TbReviews extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-bound')) return;
      this.setAttribute('data-bound', '');

      this.scroller = this.querySelector('[data-scroller]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.dialog = this.querySelector('[data-dialog]');
      this.byId = new Map();

      if (this.hasAttribute('data-curated')) {
        this.indexDomCards();
      } else {
        const payload = this.readPayload();
        const reviews = payload.reviews || [];
        if (reviews.length) {
          this.indexReviews(reviews);
          this.renderCards(reviews);
        }
        this.indexDomCards();
      }

      this.bindCards();
      this.bindNav();
      this.bindDialog();
      this.syncNav();
      this.revealCards();
    }

    revealCards() {
      if (typeof window.tbRevealCards === 'function') {
        window.tbRevealCards(this, '.tb-reviews__card');
      }
    }

    parseJsonNode(selector) {
      const node = this.querySelector(selector);
      let data = {};
      try {
        data = JSON.parse(node ? node.textContent : '{}');
      } catch (e) {
        data = {};
      }
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {};
        }
      }
      return data || {};
    }

    readPayload() {
      const widget = this.parseJsonNode('[data-tb-jdgm]');
      const grid = this.parseJsonNode('[data-tb-jdgm-grid]');
      const pid = this.getAttribute('data-product-id');
      const live = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget
        ? window.jdgm.data.reviewWidget[pid]
        : null;
      const gallery = (live && live.photo_gallery) || widget.photo_gallery || [];
      const merged = this.mergeReviews(
        gallery,
        this.mergeReviews((live && live.reviews) || widget.reviews || [], grid.reviews || [])
      );
      const scoped = this.scopedReviews(merged);
      return { reviews: this.pickFeatured(scoped) };
    }

    indexDomCards() {
      this.byId.clear();
      if (!this.scroller) return;
      this.scroller.querySelectorAll('[data-review-id]').forEach((card) => {
        const id = card.getAttribute('data-review-id');
        if (!id) return;
        const nameEl = card.querySelector('.tb-reviews__name');
        let name = '';
        if (nameEl) {
          const clone = nameEl.cloneNode(true);
          clone.querySelectorAll('.tb-reviews__verified').forEach((node) => node.remove());
          name = clone.textContent.trim();
        }
        const quoteEl = card.querySelector('.tb-reviews__quote');
        const media = card.querySelector('.tb-reviews__media img, .tb-reviews__media video');
        const src = media ? media.getAttribute('src') || '' : '';
        this.byId.set(String(id), {
          id,
          name,
          rating: card.querySelectorAll('.tb-reviews__star.is-on').length,
          body: quoteEl ? quoteEl.textContent.trim() : '',
          verified: Boolean(card.querySelector('.tb-reviews__verified')),
          src,
          video: Boolean(card.querySelector('.tb-reviews__media video'))
        });
      });
    }

    maxCount() {
      const n = Number(this.getAttribute('data-max-reviews'));
      return n > 0 ? n : 4;
    }

    pickFeatured(list) {
      const withMedia = [];
      (list || []).forEach((raw) => {
        if (this.pictureUrl(this.mediaList(raw))) withMedia.push(raw);
      });
      return withMedia.slice(0, this.maxCount());
    }

    reviewId(raw) {
      return raw && (raw.uuid || raw.id) ? String(raw.uuid || raw.id) : '';
    }

    mediaList(raw) {
      const lists = [
        raw && raw.pictures_urls,
        raw && raw.pictures,
        raw && raw.photos,
        raw && raw.videos_urls,
        raw && raw.videos
      ];
      for (let i = 0; i < lists.length; i += 1) {
        if (Array.isArray(lists[i]) && lists[i].length) return lists[i];
      }
      return [];
    }

    hasPicture(raw) {
      return Boolean(this.pictureUrl(this.mediaList(raw)));
    }

    mergeReviews(primary, secondary) {
      const byId = new Map();
      const order = [];
      const add = (raw, preferPicture) => {
        const id = this.reviewId(raw);
        if (!id) return;
        const existing = byId.get(id);
        if (!existing) {
          byId.set(id, raw);
          order.push(id);
          return;
        }
        if (preferPicture && this.hasPicture(raw) && !this.hasPicture(existing)) {
          byId.set(id, Object.assign({}, existing, raw));
        }
      };
      (primary || []).forEach((raw) => add(raw, true));
      (secondary || []).forEach((raw) => add(raw, true));
      return order.map((id) => byId.get(id));
    }

    scopedReviews(list) {
      const handle = this.getAttribute('data-product-handle') || '';
      if (!handle) return list;
      const needle = '/products/' + handle;
      return list.filter((raw) => {
        const url = raw && raw.product_url;
        if (!url) return true;
        const path = String(url).split('?')[0];
        return path === needle || path.indexOf(needle + '/') === 0 || path.slice(-needle.length) === needle;
      });
    }

    indexReviews(list) {
      this.byId.clear();
      list.forEach((raw) => {
        const review = this.normalize(raw);
        if (review.id) this.byId.set(String(review.id), review);
      });
    }

    normalize(raw) {
      const reviewer = raw.reviewer || raw.user || {};
      const pictures = this.mediaList(raw);
      const src = this.pictureUrl(pictures);
      return {
        id: raw.uuid || raw.id,
        name: raw.reviewer_name || raw.name || reviewer.name || '',
        rating: Number(raw.rating || raw.score || 0),
        body: raw.body || raw.content || this.stripHtml(raw.body_html || ''),
        verified: this.isVerified(raw.verified_buyer || raw.verified || reviewer.verified_buyer),
        src: src || '',
        video: this.isVideo(src)
      };
    }

    stripHtml(value) {
      const node = document.createElement('div');
      node.innerHTML = value || '';
      return (node.textContent || '').trim();
    }

    isVerified(value) {
      if (value === true || value === 1) return true;
      if (typeof value !== 'string') return false;
      const key = value.toLowerCase();
      return key === 'buyer' || key === 'yes' || key === 'true' || key === 'verified-buyer' || key === 'verified';
    }

    isVideo(src) {
      if (!src) return false;
      const key = String(src).toLowerCase();
      return key.indexOf('.mp4') !== -1 || key.indexOf('.webm') !== -1;
    }

    pictureUrl(pictures) {
      if (!Array.isArray(pictures) || !pictures.length) return '';
      const first = pictures.find((item) => item && item.hidden !== true) || pictures[0];
      if (!first) return '';
      if (typeof first === 'string') {
        return first.indexOf('://') === -1 ? '' : first;
      }
      const urls = first.urls || first;
      const src = urls.huge || urls.compact || urls.original || urls.small || first.url || '';
      return typeof src === 'string' && src.indexOf('://') !== -1 ? src : '';
    }

    starSvg(on) {
      return (
        '<span class="tb-reviews__star' +
        (on ? ' is-on' : '') +
        '" aria-hidden="true"><svg viewBox="0 0 20 20" width="15" height="15"><path d="M10 1.6l2.3 4.7 5.2.8-3.8 3.7.9 5.2L10 13.5 5.4 16l.9-5.2L2.5 7.1l5.2-.8L10 1.6z" fill="currentColor"/></svg></span>'
      );
    }

    starsHtml(rating) {
      let html = '';
      for (let i = 1; i <= 5; i += 1) html += this.starSvg(i <= rating);
      return html;
    }

    verifiedHtml(withLabel) {
      const check =
        '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.4 8.2l2.1 2.1 5.1-5.2" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (!withLabel) return '<span class="tb-reviews__verified" title="Verified buyer">' + check + '</span>';
      return (
        '<span class="tb-reviews__verified" title="Verified buyer">' +
        check +
        ' Verified <span class="tb-reviews__info" aria-hidden="true">i</span></span>'
      );
    }

    renderCards(list) {
      if (!this.scroller || !list.length) return;
      const html = list
        .map((raw) => {
          const review = this.normalize(raw);
          const src = review.src;
          if (!src) return '';
          return (
            '<button type="button" class="tb-reviews__card" data-review-id="' +
            this.escapeAttr(String(review.id || '')) +
            '" aria-label="' +
            this.escapeAttr(review.name || 'Review') +
            '">' +
            '<span class="tb-reviews__media">' +
            (review.video
              ? '<video src="' +
                this.escapeAttr(src) +
                '" muted playsinline preload="metadata" width="600" height="600"></video>' +
                '<span class="tb-reviews__play" aria-hidden="true"><svg viewBox="0 0 48 48" width="40" height="40"><circle cx="24" cy="24" r="23" fill="#fff"/><path d="M20 16l14 8-14 8z" fill="#111"/></svg></span>'
              : '<img src="' +
                this.escapeAttr(src) +
                '" alt="" width="600" height="600" loading="lazy" decoding="async">') +
            '</span>' +
            '<span class="tb-reviews__stars" aria-hidden="true">' +
            this.starsHtml(review.rating) +
            '</span><span class="tb-reviews__body">' +
            (review.name
              ? '<span class="tb-reviews__name">' +
                this.escapeHtml(review.name) +
                (review.verified ? this.verifiedHtml(false) : '') +
                '</span>'
              : '') +
            (review.body ? '<span class="tb-reviews__quote">' + this.escapeHtml(review.body) + '</span>' : '') +
            '</span></button>'
          );
        })
        .join('');
      if (!html) return;
      this.scroller.innerHTML = html;
      this.hidden = false;
      const stage = this.querySelector('.tb-reviews__stage');
      if (stage) stage.hidden = false;
    }

    bindCards() {
      if (!this.scroller) return;
      this.scroller.addEventListener('click', (event) => {
        const card = event.target.closest('[data-review-id]');
        if (!card || !this.scroller.contains(card)) return;
        this.openReview(card.getAttribute('data-review-id'));
      });
    }

    bindNav() {
      if (!this.prev || !this.next || !this.scroller) return;
      const step = () => {
        const card = this.scroller.querySelector('.tb-reviews__card');
        return card ? card.getBoundingClientRect().width + 18 : this.scroller.clientWidth * 0.8;
      };
      this.prev.addEventListener('click', (event) => {
        event.stopPropagation();
        this.scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      this.next.addEventListener('click', (event) => {
        event.stopPropagation();
        this.scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });
      this.scroller.addEventListener('scroll', () => this.syncNav(), { passive: true });
      window.addEventListener('resize', () => this.syncNav());
    }

    syncNav() {
      if (!this.scroller || !this.prev || !this.next) return;
      const max = this.scroller.scrollWidth - this.scroller.clientWidth - 2;
      const canScroll = max > 0;
      this.prev.hidden = !canScroll || this.scroller.scrollLeft <= 2;
      this.next.hidden = !canScroll || this.scroller.scrollLeft >= max;
      this.prev.disabled = this.scroller.scrollLeft <= 2;
      this.next.disabled = this.scroller.scrollLeft >= max;
    }

    bindDialog() {
      if (!this.dialog) return;
      const close = this.querySelector('[data-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.stopModalVideo());
    }

    stopModalVideo() {
      const video = this.dialog && this.dialog.querySelector('[data-modal-video]');
      if (!video) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
    }

    openReview(id) {
      const review = this.byId.get(String(id));
      if (!review || !this.dialog) return;
      this.stopModalVideo();
      const img = this.dialog.querySelector('[data-modal-img]');
      const video = this.dialog.querySelector('[data-modal-video]');
      const name = this.dialog.querySelector('[data-modal-name]');
      const stars = this.dialog.querySelector('[data-modal-stars]');
      const body = this.dialog.querySelector('[data-modal-body]');
      const modal = this.dialog.querySelector('.tb-reviews__modal');
      const hasMedia = Boolean(review.src);
      if (modal) modal.classList.toggle('tb-reviews__modal--quote', !hasMedia);
      if (img) {
        img.hidden = !hasMedia || review.video;
        img.src = hasMedia && !review.video ? review.src : '';
      }
      if (video) {
        video.hidden = !hasMedia || !review.video;
        if (hasMedia && review.video) video.src = review.src;
      }
      if (name) {
        name.textContent = '';
        name.append(document.createTextNode(review.name || ''));
        if (review.verified) name.insertAdjacentHTML('beforeend', this.verifiedHtml(true));
      }
      if (stars) stars.innerHTML = this.starsHtml(review.rating);
      if (body) body.textContent = review.body || '';
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      if (hasMedia && review.video && video) video.play().catch(() => {});
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    escapeAttr(value) {
      return this.escapeHtml(value).replace(/'/g, '&#39;');
    }
  }

  if (!customElements.get('tb-reviews')) {
    customElements.define('tb-reviews', TbReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutibloom-why-choose"] && !Shopify.designMode) return;
  try {
    
  const bootWhyReveal = () => {
    if (typeof window.tbRevealCards !== 'function') return;
    document.querySelectorAll('.tb-why__grid').forEach((grid) => {
      window.tbRevealCards(grid, '.tb-why__card');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhyReveal);
  } else {
    bootWhyReveal();
  }

  } catch(e) { console.error(e); }
})();
})();
